import { FC } from 'react';

import { makeCards } from '../lib';
import { IColumnScheduleProps } from '../models/IColumnScheduleProps';

import styles from './styles.module.scss';

export const ColumnSchedule: FC<IColumnScheduleProps> = ({ data }) => {
  return <div className={styles['column-schedule']}>{makeCards(data)}</div>;
};
